import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useFormContext } from "react-hook-form";

export default function SelectInput({
	name,
	formValue,
	selectList,
	helperText,
}) {
	const { watch, setValue } = useFormContext();

	return (
		<FormControl
			variant="standard"
			required
		>
			<InputLabel id={"labelSelect" + name}>{name}</InputLabel>
			<Select
				variant="standard"
				label={name}
				labelId={"labelSelect" + name}
				value={watch(formValue)}
				onChange={(e) => setValue(formValue, e.target.value)}
			>
				{selectList.map((item) => (
					<MenuItem
						key={item}
						value={item}
					>
						{item}
					</MenuItem>
				))}
			</Select>
			<FormHelperText>{helperText}</FormHelperText>
		</FormControl>
	);
}
